import React from 'react'
import styled from 'styled-components'
import AddGroup from './components/add-group'
import SendNotification from './components/send-notification'
import Table from './components/groups-table'

const AddGroupWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 32px 16px;
  margin: 0 auto;
  max-width: 1600px;
  @media(max-width: 1200px) {
    flex-direction: column;
  }

  @media(max-width: 900px) {
    padding: 16px 8px;
  }
`

const AddGroupStyled = styled(AddGroup)`
  flex-shrink: 0;
  @media(max-width: 1200px) {
    margin-bottom: 32px;
    width: 100%;
  }
`

const SendNotificationStyled = styled(SendNotification)`
  margin-left: 32px;
  @media(max-width: 1200px) {
    margin-left: 0px;
    padding-bottom: 116px;
    width: 100%;
  }
`

const Groups = (props) => {
  return (
    <React.Fragment>
      <AddGroupWrapper>
        <AddGroupStyled />
        <SendNotificationStyled />
      </AddGroupWrapper>
      <Table history={props.history} />
    </React.Fragment>
  )
}

export default Groups